<template>
  <div class="wrapper">
    <img :src="params.data.logo" class="logo" />
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.wrapper {
  display: flex;
  align-items: center;
}
.logo {
  width: 32px;
  height: 32px;
}
</style>
